import React from 'react';
import PropTypes from 'prop-types';
import gql from 'graphql-tag';
import { Container, Row, Col } from 'react-bootstrap';
import useIntegrations from '../../../../modules/react/hooks/useIntegrations';
import Button from '../../../../modules/react/components/stateless/Button';
import FacilityName from '../../stateless/FacilityName';
import { OPTION_LINKOUT } from '../../../widgets/dynamic/PayOnline/properties';
import styles from './PayOnlineEntry.scss';

const propTypes = {
  facility: PropTypes.shape({
    address: PropTypes.shape({
      address1: PropTypes.string.isRequired,
      city: PropTypes.string.isRequired,
      state: PropTypes.string.isRequired,
    }).isRequired,
    phone: PropTypes.string.isRequired,
    settings: PropTypes.shape({
      softwareProvider: PropTypes.string.isRequired,
    }).isRequired,
    tenantPortalUrl: PropTypes.string.isRequired,
  }).isRequired,
  payOption: PropTypes.string.isRequired,
};

// eslint-disable-next-line react/prop-types
const renderPayButton = ({
  facility,
  toggleIframe,
  showingIframe,
  payOption,
}) => {
  if (!facility.tenantPortalUrl) {
    return false;
  }

  if (payOption === OPTION_LINKOUT) {
    return (
      <Button
        variant="primary"
        href={facility.tenantPortalUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="color-secondary-background color-primary-background-hover button-style-class w-100"
      >
        Pay
      </Button>
    );
  }

  return (
    <div>
      <Button
        variant="primary"
        className="color-secondary-background color-primary-background-hover button-style-class d-none d-sm-block w-100"
        onClick={() => toggleIframe(facility)}
      >
        {showingIframe ? 'Close' : 'Pay'}
      </Button>
      <Button
        variant="primary"
        href={facility.tenantPortalUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="color-secondary-background color-primary-background-hover button-style-class d-block d-sm-none w-100"
      >
        Pay
      </Button>
    </div>
  );
};

const PayOnlineEntry = (props) => {
  const { facility } = props;
  const { integrations } = useIntegrations();

  const integrationsAlerting = integrations
    .filter(({ alert }) => alert.active)
    .map(({ name }) => name);

  return (
    <div>
      <Container className={styles.customGrid}>
        <Row className>
          <Col sm={2} className={styles.facilityName}>
            <FacilityName {...facility} />
          </Col>
          <Col sm={2} className={styles.facilityAddress}>
            {facility.address.address1}
          </Col>
          <Col sm={2} className={styles.facilityAddress}>
            {facility.address.city}
          </Col>
          <Col sm={2} className={styles.facilityAddress}>
            {facility.address.postal}
          </Col>
          <Col sm={2} className={styles.facilityAddress}>
            <a href={`tel:${facility.phone.replace(/[^\d]+/ig, '')}`}>
              {facility.phone}
            </a>
          </Col>
          <Col xs={12} sm={12} md={2}>
            {integrationsAlerting.includes(facility.settings.softwareProvider)
              ? (
                <div>
                  Please call <a href={`tel:${facility.phone}`}>{facility.phone}</a> to make a payment
                </div>
              )
              : renderPayButton(props)
            }
          </Col>
        </Row>
      </Container>
    </div>
  );
};

PayOnlineEntry.propTypes = propTypes;

PayOnlineEntry.fragments = {
  facility: gql`
    fragment PayOnlineEntryFacility on Facility {
      id
      __typename
      address {
        address1
        city
        state
        stateFullName
        postal
        country
      }
      phone
      settings {
        softwareProvider
      }
      tenantPortalUrl
      ...FacilityNameFacility
    }

    ${FacilityName.fragments.facility}
  `,
};

export default PayOnlineEntry;
